import $ from 'jquery';
 

const header = (() => {
  const openMenu = () => {
    // $(".header-right li").hover(function(){
    //   $(this).parent("#menu-ana-menu").find("li").addClass("hovers");
    //   $(this).addClass("not-hover");
    // },function(){
    //   $(this).parent("#menu-ana-menu").find("li").removeClass("hovers");
    //   $(this).removeClass("not-hover");
    // });
    $(".header-right .menu ul li").each(function(){
      if($(this).find(".sub-menu").length == 1){
        $(this).addClass("no-line-border");
      }
    });
    $(".header-right .menu ul li").hover(function(){
      $(this).children(".mn-menu").addClass("active");
    }, function(){
      $(this).children(".mn-menu").removeClass("active");
    });
  };

  const mobileOpenMenu = () => {
    $(".mobile-menu").on("click", function(){
      $(".mobile-menu-toggle").toggle();
      $("html").toggleClass("hide");
    });
  };

  const fullSearch = () => {
    $(".header-right .search, .mobile-search").on("click", function(){
      $(".full-search").toggleClass("active");
      $("html").toggleClass("hide");
    });
    $(".full-search .bg").on("click", function(){
      $(".full-search").removeClass("active");
      $("html").removeClass("hide");
    });
  };

  const init = () => {
    openMenu();
    mobileOpenMenu();
    fullSearch();
  };

  return {
    init,
  };
})();

export default header;
